/**
 * =====================================
 * Resource Service
 * =====================================
 *
 * Common resource actions in the API.
 * Imported by APIs.
 *
 * =====================================
 */
export default {
  /**
   * Display a list of the resource.
   *
   */
  index () {
    return this.http(this.baseUrl)
      .get(this.url)
  },

  /**
   * Display a paginated list of the resource.
   *
   */
  paginate (params) {
    return this.http(this.baseUrl)
      .get(`${this.url}/paginate`, { params })
  },

  /**
   * Display the specified resource.
   *
   */
  show (id, params = null) {
    return this.http(this.baseUrl)
      .get(`${this.url}/${id}`, { params })
  },

  /**
   * Show the form for creating a new resource.
   *
   */
  create () {
    return this.http(this.baseUrl)
      .get(`${this.url}/create`)
  },

  /**
   * Store a newly created resource in storage.
   *
   */
  store (payload) {
    return this.http(this.baseUrl)
      .post(`${this.url}`, payload)
  },

  /**
   * Show the form for editing the specified resource.
   *
   */
  edit (id) {
    return this.http(this.baseUrl)
      .get(`${this.url}/${id}/edit`)
  },

  /**
   * Update the specified resource in storage.
   *
   */
  update (id, payload) {
    return this.http(this.baseUrl)
      .put(`${this.url}/${id}`, payload)
  },

  /**
   * Remove the specified resource from storage.
   *
   */
  destroy (id) {
    return this.http(this.baseUrl)
      .delete(`${this.url}/${id}`)
  }
}
